export const BOOKING_SERVICES = [
  {
    question: 'Bleach',
    answer: {
      options: [{ menu: 'Bleach', time: '150 minutes' }],
    },
  },
  {
    question: 'Colour',
    answer: {
      options: [
        { menu: 'Balayage', time: '120 minutes' },
        { menu: 'Full-head colour', time: '120 minutes' },
        { menu: "Men's colour", time: '60 minutes' },
        { menu: 'Regrowth Colour', time: '90 minutes' },
      ],
    },
  },
  {
    question: 'Cutting',
    answer: {
      options: [
        { menu: 'Kids Cut', time: '30 minutes' },
        { menu: 'Ladies Cut', time: '30 minutes' },
        { menu: 'Ladies Cut & Wash', time: '30 minutes' },
        { menu: 'Mens Cut', time: '30 minutes' },
        { menu: 'Wash & cut', time: '30 minutes' },
      ],
    },
  },
  {
    question: 'Extensions',
    answer: {
      options: [{ menu: 'Extensions', time: '120 minutes' }],
    },
  },
  {
    question: 'Foils',
    answer: {
      options: [
        { menu: '1/2 Head foil', time: '120 minutes' },
        { menu: '1/4 Head foil', time: '90 minutes' },
        { menu: 'Full head foil', time: '150 minutes' },
      ],
    },
  },
  {
    question: 'Perm',
    answer: {
      options: [
        { menu: 'Cold perm', time: '120 minutes' },
        { menu: 'Digital&setting perm', time: '180 minutes' },
        { menu: 'Down perm', time: '30 minutes' },
        { menu: "Men's perm", time: '90 minutes' },
      ],
    },
  },
  {
    question: 'Styling',
    answer: {
      options: [
        { menu: 'Blow Dry', time: '30 minutes' },
        { menu: 'Hair Upstyles', time: '60 minutes' },
        { menu: 'Iron Curl', time: '60 minutes' },
        { menu: 'Iron Straightening', time: '60 minutes' },
        { menu: 'Wash', time: '30 minutes' },
      ],
    },
  },
  {
    question: 'Treatments',
    answer: {
      options: [
        { menu: 'Keratin smoothing', time: '120 minutes' },
        { menu: 'treatment', time: '60 minutes' },
      ],
    },
  },
  {
    question: 'straightening',
    answer: {
      options: [{ menu: 'Permanent Straightening', time: '120 minutes' }],
    },
  },
  {
    question: 'toner',
    answer: {
      options: [{ menu: 'Toner', time: '30 minutes' }],
    },
  },
];

export const MONTH_RANGE = 3;
